import { Map as ImmutableMap } from 'immutable';
import React from 'react';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { CashFlowTransaction } from 'app-components/flux/transactions/transactionsTypes';
import type { Dispatch } from 'redux';
import { InvoicePaymentUpsertAction } from 'components/InvoicePayment/actions';
import {
  DIALOG_TYPE as CONFIRMATION_DIALOG_TYPE,
  mkConfirmationDialogProps,
} from 'components/Dialogs/ConfirmationDialog';

import RecordInvoicePaymentDialogContent from './components/RecordInvoicePaymentDialogContent';

type Params = {
  closeAll: () => void;
  currentTxn: CashFlowTransaction;
  dispatch: Dispatch;
  txnId?: string | null;
};

export function showRecordInvoicePaymentDialog({ closeAll, currentTxn, dispatch, txnId }: Params): void {
  dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        id: 'mark-as-payment',
        type: CONFIRMATION_DIALOG_TYPE,
        props: ImmutableMap(
          mkConfirmationDialogProps({
            title: 'Record invoice payment',
            content: <RecordInvoicePaymentDialogContent />,
            confirmLabel: 'Apply Payment',
            confirmAction: () => {
              closeAll();
              dispatch(
                InvoicePaymentUpsertAction({
                  action: 'EDIT_ALLOCATIONS',
                  context: 'details-dialog',
                  initIdType: 'PAYMENT',
                  initId: txnId,
                  initScreen: currentTxn?.split?.items ? 'SPLIT' : 'MAIN',
                }),
              );
            },
            denyLabel: 'Not Now',
            denyAction: closeAll,
          }),
        ),
      }),
    ),
  );
}
